var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("div", { staticClass: "thumb-image mt-3" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        )
                      }
                    },
                    [
                      _vm.position < 3
                        ? _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: _vm.item.images.all[0].urlMiddle,
                              title: _vm._f("itemName")(_vm.item),
                              alt: _vm._f("itemName")(_vm.item)
                            }
                          })
                        : _c("lazy-img", {
                            attrs: {
                              "image-url": _vm.item.images.all[0].urlMiddle,
                              title: _vm._f("itemName")(_vm.item),
                              alt: _vm._f("itemName")(_vm.item),
                              "picture-class": "img-fluid"
                            }
                          })
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "add-to-wishlist-wrapper" },
            [
              _c("add-to-wish-list", {
                attrs: { "variation-id": _vm.item.variation.id }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("store-special", [
            _vm.storeSpecial
              ? _c("item-store-special", {
                  attrs: {
                    "store-special": _vm.storeSpecial,
                    "recommended-retail-price": _vm.item.prices.rrp,
                    "variation-retail-price": _vm.item.prices.default,
                    "special-offer-price": _vm.item.prices.specialOffer,
                    "decimal-count": _vm.decimalCount,
                    "bundle-type": _vm.item.variation.bundleType,
                    "item-type": _vm.item.item.itemType
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title small",
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("itemName")(_vm.item))
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", [
                        _vm._v(
                          '${ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }'
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("a", {
                  staticClass: "listItemText",
                  attrs: {
                    href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                  },
                  domProps: {
                    innerHTML: _vm._s(_vm.item.texts.shortDescription)
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thumb-meta mt-2" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "prices",
                        class: [
                          _vm.item.prices.rrp &&
                          _vm.item.prices.rrp.price.value > 0 &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.unitPrice.value
                            ? "hasCrossPrice"
                            : ""
                        ]
                      },
                      [
                        _vm.item.prices.rrp &&
                        _vm.item.prices.rrp.price.value > 0 &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.unitPrice.value
                          ? _c("div", { staticClass: "price-view-port" }, [
                              _vm.item.prices.specialOffer
                                ? _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            true
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.rrp.unitPrice
                                              .formatted
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "price" },
                          [
                            _vm.item.item.itemType === "set"
                              ? [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSetPrice",
                                          { price: _vm.itemSetPrice }
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              : _vm.itemGraduatedPriceisCheapestSorting
                              ? [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                          "
                                  )
                                ]
                              : _vm.itemGraduatedPricesalableVariationCount
                              ? [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm._f("specialOffer")(
                                          _vm.item.prices.default.unitPrice
                                            .formatted,
                                          _vm.item.prices,
                                          "unitPrice",
                                          "formatted"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFootnote"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "availability",
                        class: "available-" + _vm.item.variation.availability.id
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.item.variation.availability.names.name) +
                            "\n                  "
                        )
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                _vm.item.prices.default.lowestPrice.value && _vm.hasCrossPrice
                  ? _c("div", { staticClass: "category-lowest-price small" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate("Ceres::Template.itemLowestPrice", {
                              price:
                                _vm.item.prices.default.lowestPrice.formatted
                            })
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !(
                  _vm.item.unit.unitOfMeasurement === "C62" &&
                  _vm.item.unit.content === 1
                )
                  ? _c("div", { staticClass: "category-unit-price small" }, [
                      _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                      ]),
                      _vm._v(" "),
                      _vm.item.variation.mayShowUnitPrice
                        ? _c("span", [_vm._v(" | " + _vm._s(_vm.basePrice))])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }